import { InjectionToken } from '@angular/core';

import environment from '@environments/environment';

import { GridType } from '@data-access/grid-views';

import { DEFAULT_BASE_GRID_PROPS } from './base-grid-props.constant';

import { OrganizationStudyGrid } from '../types';

/* eslint-disable @typescript-eslint/naming-convention */

export const studyListInitialState: OrganizationStudyGrid = {
  data: [],
  currentUrl: '',
  gridType: 'study' as GridType,
  views: [],
  ...DEFAULT_BASE_GRID_PROPS,
};

export const ORGANIZATION_STUDY_GRID_STATE =
  new InjectionToken<OrganizationStudyGrid>('Organization Study grid state', {
    factory: () => ({ ...studyListInitialState }),
  });

export const ORGANIZATION_URL = `${environment.irisApi}/organization/`;
export const FACILILITIES_URL = `${environment.irisApi}/facilities/`;
